import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ApproverGroupPayload} from '../types'

import {ApproverGroupsQueryKey} from './useApproverGroups'
import {QueryKey as ApproversByFunctionIdQueryKey} from './useApproversByFunctionId'

export const useEditApproverGroups = (
  {plantId}: {plantId: string},
  options?: UseMutationOptions<never, AxiosError, ApproverGroupPayload>
) => {
  const queryClient = useQueryClient()

  return useMutation<never, AxiosError, ApproverGroupPayload>({
    mutationFn: async (groups) => {
      const path = `/shifthandover/${plantId}/system-change-requests/approver-groups`
      const {data} = await ApiClient.axiosInstance.put<never>(path, groups)
      return data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({queryKey: [ApproverGroupsQueryKey]})
      await queryClient.invalidateQueries({queryKey: [ApproversByFunctionIdQueryKey]})
      options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
